export type RemovePayloadCart = {
    type: "cart" | "group" | "product" | "item";
    id: string | number;
};

export const buildQuoteRemoveUrl = (
    payload: RemovePayloadCart,
    quoteId: string | number,
): string => {
    const { type, id } = payload;
    let url = `quotes/remove/items`;

    switch (type) {
        case "cart":
            url += `?quoteId=${id}`;
            break;
        case "group":
            url += `?quoteId=${quoteId}&groupId=${id}`;
            break;
        case "product":
            url += `?quoteId=${quoteId}&productId=${id}`;
            break;
        case "item":
            url += `?quoteId=${quoteId}&quoteItemId=${id}`;
            break;
        default:
            throw new Error(`Invalid delete type: ${type}`);
    }

    return url;
};

export const buildCartRemoveUrl = (payload: RemovePayloadCart): string => {
    const { type, id } = payload;
    let url = `cart/remove/items`;

    switch (type) {
        case "cart":
            url += `?isCart=1`;
            break;
        case "group":
            url += `?groupId=${id}`;
            break;
        case "product":
            url += `?productId=${id}`;
            break;
        case "item":
            url += `?cartItemId=${id}`;
            break;
        default:
            throw new Error(`Invalid delete type: ${type}`);
    }

    return url;
};
